import { useEffect, useState } from "react";
import { api, formatCurrency, formatDate } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

export default function WaiterHistory() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/orders?mine=true"); setOrders(data); }
      catch (err) { console.error("waiter history load failed:", err); }
    })();
  }, []);

  return (
    <div className="animate-fade-up" data-testid="waiter-history-page">
      <p className="text-xs uppercase tracking-[0.3em] text-[#7248ae] mb-2">Tu trabajo</p>
      <h1 className="font-display text-3xl sm:text-4xl font-black text-[#1a0f2e] mb-6 tracking-tight">Historial</h1>

      {orders.length === 0 && (
        <Card className="p-8 text-center border-dashed border-[#b182ec]/40">
          <p className="text-[#7248ae]">Aún no tienes pedidos.</p>
        </Card>
      )}

      <div className="space-y-3" data-testid="history-list">
        {orders.map(o => (
          <Card key={o.id} className="p-4 border border-[#b182ec]/30 rounded-2xl" data-testid={`history-order-${o.id}`}>
            <div className="flex items-center justify-between mb-2">
              <div>
                <p className="font-display text-xl font-bold text-[#1a0f2e]">Mesa {o.table_number}</p>
                <p className="text-xs text-[#7248ae]">{formatDate(o.created_at)}</p>
              </div>
              <Badge className={o.status === "paid" ? "bg-[#10b981]" : "bg-[#3e166c]"}>{o.status === "paid" ? "Pagada" : "Abierta"}</Badge>
            </div>
            <div className="flex items-center justify-between">
              <p className="text-sm text-[#7248ae]">{o.items.length} platillo(s)</p>
              <div className="flex items-center gap-3">
                <span className="font-display text-lg font-bold text-[#3e166c]">{formatCurrency(o.total)}</span>
                <Button size="sm" variant="outline" onClick={() => window.open(`/print/${o.id}?type=receipt`, "_blank")} className="border-[#b182ec]/50" data-testid={`print-${o.id}`}>
                  <Printer className="h-4 w-4" />
                </Button>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
